import en from '../shared-solo/languages/en'

export default {
  ...en,
}
